import * as React from 'react';

import {PlanComparisonTable} from 'shells/billing/plan-comparison/plan-comparison-table';

import {useGetPlanComparisons} from '../../setup/billing/graphql/hooks/use-get-plan-comparisons';

export type SuiteType = 'sales' | 'marketing' | 'engagement';

type Props = {
    suiteType: SuiteType;
};

export function PlanComparisonRoot(props: Props) {
    const {planComparisons, isLoading} = useGetPlanComparisons(props.suiteType);

    return (
        <div id='plan-comparisons'>
            {planComparisons && !isLoading && (
                <PlanComparisonTable
                    plans={planComparisons.planStubs}
                    features={planComparisons.featureGroups}
                />
            )}
        </div>
    );
}
